import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import WarningDialog from './WarningDialog';

const Step1 = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const data = JSON.parse(atob(id));

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  return (
    <div style={{ minHeight: '100vh', maxWidth: '1100px' }}>
      <div className='red-back-text'>{`Dear ${data?.u}, when repaying the loan, please confirm that the following information is your personal information. The repayment link with incorrect information or no such information is not the official repayment channel. Beware of scams!`}</div>
      <div className='gray-back-text'>
        <div className='left-side'>
          <p>Borrower Name:</p>
          <p>Loan APP:</p>
          <p>Repayment Amount:</p>
        </div>
        <div className='right-side'>
          <p>{data?.u}</p>
          <p>{data.ap}</p>
          <p className='red'>{data?.a}</p>
        </div>
      </div>
      <div className='borderd'>
        <p>Confirm Repayment Amount</p>
        <p className='red-button'>{data?.a}</p>
      </div>
      <button className='submit-utr' onClick={() => navigate(`/step2/${id}`)}>
        Repayment
      </button>
      <WarningDialog />
    </div>
  );
};

export default Step1;
